import * as firebase from 'firebase/app'
import * as React from 'react'
import { RouterProps } from 'react-router'
import { Link, NavLink, Route } from 'react-router-dom'

import CompanyEditor from 'components/CompanyEditor'
import Icon from 'components/Icon'
import Statistics from 'components/Statistics/'
import { IAuthState } from 'containers/Auth'
import AuthContext from 'context/AuthContext'
import { ICompany } from 'interfaces/ICompany'
import { PATHS } from 'paths'

interface ICompanyState {
  company: ICompany
}

class Company extends React.Component<
  RouterProps & {
    companies: IAuthState['companies']
    company: IAuthState['company']
    logo: IAuthState['logo']
    getLogo?: () => void
    setCompany?: (key: string) => void
  },
  ICompanyState
> {
  public logo: HTMLInputElement | null

  public company = (id: string): ICompany => {
    return this.props.companies[id] || {}
  }

  public handleLogotype = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    const { currentUser } = firebase.auth()

    if (!this.props.company) {
      throw new Error('Company not set')
    }

    if (currentUser && this.logo && this.logo.files) {
      const file = this.logo.files[0]
      if (file) {
        if (file.type !== 'image/svg+xml') {
          return alert('File is not an SVG logo')
        }

        firebase
          .storage()
          .ref(`logos/${this.props.company}.svg`)
          .put(file)
          .then(() => {
            if (this.props.getLogo) {
              this.props.getLogo()
            }

            if (this.logo) {
              this.logo.value = ''
            }
          })
      }
    }
  }

  public render() {
    const { props, company: client } = this

    return (
      <div>
        <ul id="nav">
          <li>
            <NavLink activeClassName="active" exact to={PATHS.company.index}>
              <Icon icon="view" />
              Visa företag
            </NavLink>
          </li>
          <li>
            <NavLink activeClassName="active" to={PATHS.company.create}>
              <Icon icon="add" />
              Lägg till företag
            </NavLink>
          </li>
          {this.props.company && (
            <>
              <li>
                <NavLink exact activeClassName="active" to={PATHS.company.logo}>
                  <Icon icon="image" />
                  Logotyp
                </NavLink>
              </li>
              <li>
                <NavLink
                  exact
                  activeClassName="active"
                  to={PATHS.company.statistics}
                >
                  <Icon icon="chart" />
                  Statistik
                </NavLink>
              </li>
            </>
          )}
        </ul>
        <Route
          exact
          path={PATHS.company.index}
          render={() => (
            <>
              <table>
                <thead>
                  <tr>
                    <th>Företag</th>
                    <th colSpan={1} />
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(props.companies).map(id => (
                    <tr key={id}>
                      <td>
                        <a
                          onClick={() =>
                            this.props.setCompany && this.props.setCompany(id)
                          }
                        >
                          <strong>{client(id).name}</strong>
                        </a>
                      </td>
                      <td className="border">
                        <Link to={PATHS.company.edit(id)}>
                          <Icon icon="edit" />
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}
        />
        <Route
          exact
          path={PATHS.company.create}
          render={p => <CompanyEditor {...p} />}
        />
        <Route
          exact
          path={PATHS.company.edit()}
          render={p => <CompanyEditor {...p} />}
        />
        <Route
          exact
          path={PATHS.company.logo}
          render={() =>
            this.props.company && (
              <div>
                {props.logo && <img src={props.logo} />}
                <div className="divider" />
                <h3>Ladda upp logotyp</h3>
                <span className="sub">
                  <b>SVG</b>
                </span>
                <br />
                <form
                  encType="multipart/form-data"
                  onSubmit={this.handleLogotype}
                >
                  <input
                    type="file"
                    name="logo"
                    ref={node => (this.logo = node)}
                  />
                  <div className="submit">
                    <button className="button">
                      <span>Ladda upp</span>
                    </button>
                  </div>
                </form>
              </div>
            )
          }
        />
        <Route exact path={PATHS.company.statistics} component={Statistics} />
      </div>
    )
  }
}

export default (props: RouterProps) => (
  <AuthContext.Consumer>
    {({ company, companies, logo, getLogo, setCompany }) => (
      <Company
        {...props}
        companies={companies}
        company={company}
        logo={logo}
        getLogo={getLogo}
        setCompany={setCompany}
      />
    )}
  </AuthContext.Consumer>
)



// WEBPACK FOOTER //
// ./src/components/Company/Company.tsx